module.exports = __webpack_public_path__ + "img/timeline.91454b7f.svg";